import { UnknownError } from './constants';
import { Err, Ok } from './classes';
export function ok(data = undefined) {
    return new Ok(data);
}
export function err(error = UnknownError, reason = undefined) {
    return new Err(error, reason, err);
}
//# sourceMappingURL=functions.js.map